import customAxios from "../../customAxios";

import { LOCATION_PROVINCE } from "../../routes";
import {locationNamespace} from "../../../types/location.namespace";

const searchProvince = async (props: locationNamespace.province.request): Promise<any> => {
  let thisUrl = `${LOCATION_PROVINCE}?`;

  if (props?.search && props.search.trim().length > 0) thisUrl += `&search=${props.search}`;

  if (props?.limit) thisUrl += `&limit=${props?.limit}`;
  if (props?.page ) thisUrl += `&page=${props.page}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({LOCATION_PROVINCE: error});
  }
};

export default searchProvince;
